module.exports = __webpack_public_path__ + "static/img/04.5604e3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/04.png
// module id = L9Wr
// module chunks = 0